import React from 'react'
import MyAccountBookingComp from '../../components/Account/MyAccountBookingComp'

const MyAccount = () => {
  return (
    <>
        <MyAccountBookingComp/> 
    </>
  )
}

export default MyAccount